import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { RoutingService } from 'src/app/service/routing.service';
import {
  BreakpointService,
  ScreenSize,
} from 'src/app/shared/services/breakpoints.service';

/**
 * Persistent global-filter strip in the nav bar: timeframe, score, language and
 * the filters pop-up trigger. Rendered on the same routes the filters trigger
 * used to be, and hidden (not destroyed) on mobile, where `app-menu-options`
 * still owns these controls.
 */
@Component({
  selector: 'app-global-filters-bar',
  templateUrl: './global-filters-bar.component.html',
  styleUrls: ['./global-filters-bar.component.scss'],
})
export class GlobalFiltersBarComponent {
  readonly screenSize$: Observable<ScreenSize>;

  constructor(
    public routing: RoutingService,
    breakpointService: BreakpointService,
  ) {
    this.screenSize$ = breakpointService.screenSize$;
  }
}
